import { render } from "./Marking.vue?vue&type=template&id=796e491e&scoped=true"
import script from "./Marking.vue?vue&type=script&lang=js"
export * from "./Marking.vue?vue&type=script&lang=js"

import "./Marking.vue?vue&type=style&index=0&id=796e491e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796e491e"]])

export default __exports__